module.exports = __webpack_public_path__ + "img/图层18.7e923ad2.png";